import React, { FC, useContext, useEffect, useRef, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { AdminHeader, StudentHeader } from '../../components/Header'
import '../../index.css'

import { AdminRequestPaginateContext } from '../../store/AdminRequestContext'
import { AuthContext } from '../../store/AuthContext'
import $api from '../../http'
import { FormFieldInput } from '../../components/formFieldInput'
import { IRequestDetail } from '../../types/admindetailpage'
import { INomination } from '../../types/request'


export const AdminNominationChangePage: FC = () => {
    const [ nomination, setNomination] = useState<INomination>()
    const [subArray, setSubArray] = useState<{
        user_chose: number
        criterion: number
        id: number
        name: string
        paymentVPO: number
        paymentSPO: number
      }[]>([])
    const { id } = useParams()
    const [nomid, setNomId] = useState('')
    const [subid, setSubId] = useState('')
    const[loading, setLoading] = useState(false)
    const { requests,count,nominations, statuses, fetchPagginatedRequests } = useContext(AdminRequestPaginateContext)
    const nominationRef = useRef(null)
    const subNominationRef = useRef(null)
    const qs = requests.filter(r => r.company.id === Number(id))
    const {financingSource } = useContext(AuthContext)
    let navigate = useNavigate(); 

    const fetchNomRequest = async () => {
        const resp = await $api.get(`/api/requests/${id}/`).then((resp) => {
            setNomination(resp.data.criterion)
            if(resp.data.criterion.sub_criterion){
              setSubArray(resp.data?.criterion?.sub_criterion)
            }else{
              setSubArray([])
            }
            
        })
        
         
      }
    

    useEffect(() => {
      
      fetchNomRequest()
      
      }, [])
      
    const sendSaveNomination = async (id: string, criterion_id:string, sub_criterion_id:string) => {
      const response = await $api.post('/api/edit/request-nomination/' + id + '/', {
        'criterion' : criterion_id,
        'sub_criterion':sub_criterion_id
      })
    }

    // const sendSaveRequest = (id:String) => {
        
    //     const response = $api
    //         .post('/api/edit/application/' + id  + '/', {
    //             'lastname':fio?.slice(0, fio.search(' ')),
    //             "firstname":fio?.slice(fio.search(' '), fio.lastIndexOf(' ')),
    //             'patronymic': fio?.slice(fio.lastIndexOf(' ')),
    //             "institut": institute,
    //             "phone": phone,
    //             "profile":direction,
    //             "form":educationForm,
    //             //"source_finance":financingSource,
    //             //"level":level,
    //             //"course":course,
    //             "INN":INN,
    //             "SNILS":SNILS,
    //             "address":address,
    //             "factadress":factaddress,
    //             //"citizenship":citizenship,
    //             "passport_seria":passportsSeria,
    //             "passport_number":passportNumber,
    //             "passport_IssueDate":formatDate,
    //             "passport_IssueBy":passportIssueBy,
    //             "passport_DepartmentCode":passportDepartmentCode

    //         }).then(r => console.info(r))
    // }

    function formatDate(passportIssueDate: string | number | Date) {
        let d = new Date(passportIssueDate),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
        return  [year, month, day].join('-'); ;
    }
    return <> 
        <AdminHeader />
       
        <div className='container' style={{marginTop:'50px',marginRight: 70, marginLeft: 70}}>
        <h2>Изменение критерия студента</h2>
        <h4 style={{marginTop: 50}}>Выберите критерий из списка для продолжения</h4>
        <select  className='com-3' onChange={(event) => {
              
              const nom = nominations.find((n) =>  parseInt(n.id, 10) === parseInt(event.target.value, 10))?.sub_criterion
              if (nom === undefined){
                setSubArray([])
              }else{
                setSubArray(nom)
              }
              
            }}        
            ref={nominationRef}
            style={{display:"block", marginLeft: 180, marginTop: 50,   wordWrap: 'break-word',
            whiteSpace: 'normal'}}>
            
              <option selected value={nomination?.id} key={nomination?.id}>{nomination?.name}</option>
            {nominations.filter(n => {
                  if (financingSource === 'Полное возмещение затрат') {
                  const paymentStatus = n.payment_status === true 
                  const studentFinanceSource = financingSource === 'Полное возмещение затрат'
                  
                  return !(qs.map(r => r.nomination.name).indexOf(n.name) + 1) && paymentStatus && studentFinanceSource
                      } else {
                    return !(qs.map(r => r.nomination.name).indexOf(n.name) + 1)
                    
                  }
                  
                }
                
                
              ).map(n => (   
                
                <option  value={n.id} key={n.id} >
                 {n.name}
                </option>
              ))
                }  
                                    
        </select>
        {subArray.length !==0 ?
            <div>
               <h4>Выберите подкритерий из списка для продолжения</h4>
                <select className='com-3' ref={subNominationRef} style={{display: 'block',marginLeft: 180, marginTop: 50}}>
                  {subArray.map(sub => (
                    <option value={sub.id} key={sub.id}>{sub.name}</option>
                  ))}

                </select>

            </div> : <div></div>

        }

        <button className='btn light-blue darken-2 waves-effect waves-light'
            onClick={(e) =>  {
                e.preventDefault();
                //@ts-ignore
                const subCriterion = subNominationRef?.current?.value !==undefined
                if(subCriterion)
                {
                  //@ts-ignore
                  sendSaveNomination(id,nominationRef?.current?.value,subNominationRef?.current?.value)
                }else{
                //@ts-ignore
                 sendSaveNomination(id,nominationRef?.current?.value,'1')
                 
                }
                //@ts-ignore
                console.log('nom',nominationRef?.current?.value)
                //@ts-ignore
                console.log('subnom',subNominationRef?.current?.value)
                fetchNomRequest()
                
                navigate(`/admin/requests/${id}/`)    
            }}    
            >save
        </button>
    </div>
    
  </>

}